class FooterAccordions extends HTMLElement {
  constructor () {
    super()

    this.itemEls = this.querySelectorAll('[data-el="footer-accordions.item"]')

    this.initialiseAccordions()
    this.unsetTabindex()
  }

  initialiseAccordions () {
    this.itemEls.forEach(itemEl => {
      const triggerEl = itemEl.querySelector(
        '[data-el="footer-accordions.trigger"]',
      )

      this.handleClick = this.handleClick.bind(this)

      triggerEl.addEventListener('click', this.handleClick)
    })
  }

  handleClick (event) {
    const triggerCurrentState =
      event.target.getAttribute('aria-expanded') === 'true'
    const newState = !triggerCurrentState

    event.target.setAttribute('aria-expanded', newState)

    const itemEl = event.target.closest('[data-el="footer-accordions.item"]')
    const linksEl = itemEl.querySelector('[data-el="footer-accordions.links"]')

    itemEl.style.setProperty('--Max_Height', `${linksEl.offsetHeight}px`)
    itemEl.classList.toggle('ft-Accordion_Item-active')

    this.setLinkTabindex(itemEl, newState)

    if (newState) {
      itemEl.querySelector('[data-el="footer-accordions.links"] a')?.focus()
    }
  }

  setLinkTabindex (itemEl, isFocusable) {
    const links = itemEl.querySelectorAll('[data-el="footer-accordions.link"]')
    const tabindexValue = isFocusable ? '0' : '-1'

    links.forEach(link => {
      link.setAttribute('tabindex', tabindexValue)
    })
  }

  unsetTabindex () {
    const links = this.querySelectorAll('[data-el="footer-accordions.link"]')

    if (links && links.length) {
      links.forEach(item => {
        item.setAttribute('tabindex', -1)
      })
    }
  }
}

customElements.define('footer-accordions', FooterAccordions)
